import { useState } from "react";
import Modal from "react-responsive-modal";
import { useProfile, useUser } from "../../../data/context/auth-context";
import style from "./style.module.scss";

interface CliTokenButtonProps {
  isInverted?: boolean;
  className?: string;
}

const CliTokenButton = ({ isInverted, className }: CliTokenButtonProps) => {
  const profile = useProfile();
  const user = useUser();
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  if (profile?.role !== "admin") {
    return null;
  }

  const refreshToken = user?.refreshToken || "";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(refreshToken);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className={`${style.link} ${isInverted ? style.inverted : ""} ${className || ""}`}
      >
        CLI Token
      </button>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        center
        classNames={{ modal: style.modal }}
      >
        <h2 className={style.title}>CLI Authentication Token</h2>
        <p className={style.instructions}>
          Copy this token and paste it when running <code>lymaprint auth</code>
        </p>
        <textarea
          readOnly
          value={refreshToken}
          className={style.tokenInput}
          rows={4}
          onClick={(e) => (e.target as HTMLTextAreaElement).select()}
        />
        <button onClick={handleCopy} className={style.copyButton}>
          {copied ? "Copied!" : "Copy Token"}
        </button>
      </Modal>
    </>
  );
};

export default CliTokenButton;
